import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, TextField, Button } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';

/**
 * Form component for adding new keywords
 *
 * @param {Object} props Component props
 * @param {Function} props.onAddKeyword Function to handle adding a new keyword
 * @param {boolean} props.isSubmitting Whether a submission is in progress
 * @returns {JSX.Element} Rendered form component
 */
const AddKeywordForm = ({ onAddKeyword, isSubmitting = false }) => {
  const [newKeyword, setNewKeyword] = useState('');

  const handleSubmit = () => {
    if (newKeyword.trim()) {
      onAddKeyword(newKeyword.trim());
      setNewKeyword('');
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleSubmit();
    }
  };

  return (
    <Box sx={{ display: 'flex', gap: 1, mb: 3 }}>
      <TextField
        fullWidth
        size="small"
        placeholder="Add new keyword..."
        value={newKeyword}
        onChange={(e) => setNewKeyword(e.target.value)}
        onKeyPress={handleKeyPress}
        disabled={isSubmitting}
        sx={{
          '& .MuiOutlinedInput-root': {
            backgroundColor: 'white',
          },
        }}
      />
      <Button
        variant="contained"
        onClick={handleSubmit}
        disabled={!newKeyword.trim() || isSubmitting}
        startIcon={<AddIcon />}
        size="small"
        sx={{ minWidth: 100 }}
      >
        {isSubmitting ? 'Adding...' : 'Add'}
      </Button>
    </Box>
  );
};

AddKeywordForm.propTypes = {
  onAddKeyword: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool,
};

export default AddKeywordForm;
